import React from 'react';
import { Box, Typography } from '@mui/material';
import PegValueModule from './PegValueModule';
import ReferralStrategyDropdown from './ReferralStrategyDropdown/ReferralStrategyDropdown';
import {
  ReferralStrategyVariant,
  isCoverageEndorsementsState,
  type ReferralStrategyForEdit,
} from '../types';
import UnifiedMessagesButton from './UnifiedMessagesButton';
import { useUnderwriterContext } from '../provider/UnderwriterProvider';

interface UnderwriterLineItemActionsProps {
  isPegValue: boolean;
  warnings?: string[];
  errors?: string[];
  referralReasons?: string[];
  referralReasonsForEdit?: string[];
  referralStrategyForEdit?: ReferralStrategyForEdit | null;
  onUpdatePegValue: (isPegValue: boolean) => void;
  onUpdateReferralStrategy?: (strategy: ReferralStrategyForEdit) => void;
}

const UnderwriterLineItemActions = ({
  isPegValue,
  warnings,
  errors,
  referralReasons,
  referralReasonsForEdit,
  referralStrategyForEdit,
  onUpdatePegValue,
  onUpdateReferralStrategy,
}: UnderwriterLineItemActionsProps) => {
  const context = useUnderwriterContext();
  const isMTEFlow = isCoverageEndorsementsState(context.state);

  return (
    <>
      <Typography
        component="span"
        sx={{
          ml: '0.25rem',
          mr: '0.75rem',
          color: 'text.secondary',
          fontSize: '1rem',
          flexShrink: 0,
        }}
      >
        |
      </Typography>
      <Box
        display="flex"
        alignItems="center"
        gap="0.5rem"
        sx={{ flexShrink: 0 }}
      >
        <PegValueModule
          isPegValue={isPegValue}
          onUpdatePegValue={onUpdatePegValue}
        />
        {onUpdateReferralStrategy && !isMTEFlow && (
          <ReferralStrategyDropdown
            variant={ReferralStrategyVariant.SINGLE}
            value={referralStrategyForEdit}
            onChange={onUpdateReferralStrategy}
          />
        )}
        <UnifiedMessagesButton
          warnings={warnings}
          errors={errors}
          referralReasons={referralReasons}
          referralReasonsForEdit={referralReasonsForEdit}
        />
      </Box>
    </>
  );
};

export default UnderwriterLineItemActions;
